import { KulionerReceiptSectionProps } from "../types";
import { colors, margin } from "../constants";
import { formatDateWithoutTime } from "@/app/infrastructures/misc/Utils";

export const renderOrderDetails = ({
  doc,
  x,
  y,
  pageWidth,
  data
}: KulionerReceiptSectionProps): number => {
  y += 2;
  const widthColumnOrderDetail = pageWidth / 3;

  doc.setDrawColor(colors.border);
  doc.roundedRect(x, y, pageWidth - margin.right - 5, 8, 1.5, 1.5, "S");

  const renderColumn = (
    title: string,
    value: string,
    xOffset: number,
    isRed = false
  ): void => {
    doc.setTextColor(colors.secondary);
    doc.setFont("helvetica", "bold");
    doc.text(title, xOffset, y + 3);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(isRed ? colors.accent : colors.primary);
    doc.text(value, xOffset, y + 6);
  };

  renderColumn(
    "Tanggal pesanan",
    formatDateWithoutTime(data?.koCreatedAt),
    x + 2
  );
  renderColumn(
    "Order ID",
    data?.koOrderId,
    widthColumnOrderDetail + margin.right,
    true
  );
  renderColumn(
    "Nomor STT",
    data?.koOrderSttNo || "-",
    widthColumnOrderDetail * 2 + margin.right,
    true
  );

  return y;
};
